module.exports = __webpack_public_path__ + "img/align_left.fe59fd17.svg";